module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-atami-3-91177382ddfd6896b5d2169424e967a7.webp";